module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [(_vm.$route.name !== 'ItemBank') ? _c('form', {
    staticClass: "form-inline pull-right",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doFilter()
      }
    }
  }, [(_vm.filterCriteria.length > 0) ? _c('div', {
    staticClass: "form-group m-r-10"
  }, _vm._l((_vm.filterCriteria), function(criteria, index) {
    return _c('span', {
      key: index,
      staticClass: "label label-info m-r-5"
    }, [_vm._v(_vm._s(criteria))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Kata kunci",
      "required": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field),
      expression: "field"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.field = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.headers), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                    " + _vm._s(value) + "\n                ")])
  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                Hapus Filter\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderBy),
      expression: "orderBy"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateOrderBy]
    }
  }, [_c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Baru ke Lama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Lama ke Baru")])])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [(!_vm.$attrs.hidenumber) ? _c('th', [_vm._v("No.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                    " + _vm._s(header) + "\n                ")])
  }), _vm._v(" "), (_vm.hasAction || _vm.hasExport) ? _c('th', [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('th', [_vm._v("Status")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentPageItems), function(values, key) {
    return _c('tr', {
      key: key,
      class: {
        success: _vm.selectedRow == key
      },
      on: {
        "dblclick": function($event) {
          return _vm.selectRowAndFinish(key)
        },
        "click": function($event) {
          return _vm.selectRow(key)
        }
      }
    }, [(!_vm.$attrs.hidenumber) ? _c('td', [_vm._v("\n                    " + _vm._s(_vm.startNumber + key + 1) + "\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((values.data), function(value, index) {
      return _c('td', {
        key: index
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(value)
        }
      }, [_vm._v(_vm._s(index))])])
    }), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('td', _vm._l((values.status), function(values, index) {
      return _c('div', {
        key: index
      }, [_c('span', {
        staticClass: "label",
        class: {
          'label-warning': values === 'CHECKOUT',
          'label-primary': values === 'CONFIRMED',
          'label-danger': values === 'EXPIRED' ||
            values === 'REJECTED',
          'label-success': values === 'ACTIVATED',
          'label-default': values === 'REFUND',
        },
        staticStyle: {
          "font-size": "0.9em"
        }
      }, [_vm._v(_vm._s(values))])])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.hasExport) ? _c('td', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row",
        "justify-content": "flex-start",
        "align-items": "baseline"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.exportItem(key)
        }
      }
    }, [_vm._v("\n                        Export\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.hasAction) ? _c('td', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row",
        "justify-content": "flex-start",
        "align-items": "baseline"
      }
    }, [(_vm.hasEdit) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.editItem(key)
        }
      }
    }, [_vm._v("\n                        Edit\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs m-1",
      on: {
        "click": function($event) {
          return _vm.deleteItem(key)
        }
      }
    }, [_vm._v("\n                        Hapus\n                    ")]), _vm._v(" "), (_vm.hasPreview) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-preview m-1",
      attrs: {
        "data-toggle": "modal",
        "data-target": ".bd-example-modal-sm"
      },
      on: {
        "click": function($event) {
          return _vm.previewVideo(values)
        }
      }
    }, [_vm._v("\n                        Preview\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'DRAFT') ? _c('button', {
      staticClass: "btn btn-success btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.publishing(values)
        }
      }
    }, [_vm._v("\n                        Publish\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'PUBLISHED') ? _c('button', {
      staticClass: "btn btn-danger btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.unpublishing(values)
        }
      }
    }, [_vm._v("\n                        Unpublish\n                    ")]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]) : _vm._e()], 2)
  }), 0)]), _vm._v(" "), (_vm.$route.name !== 'ItemBank') ? _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                " + _vm._s(this.maxPage) + "\n            ")])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("\n                Previous\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("\n                Next\n            ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Filter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade bd-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "mySmallModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69dcedc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/DataTable.vue
// module id = 1440
// module chunks = 1